module.exports = {"320581100":"虞山镇","320581101":"梅李镇","320581102":"海虞镇","320581104":"古里镇","320581105":"沙家浜镇","320581106":"支塘镇","320581107":"董浜镇","320581110":"辛庄镇","320581111":"尚湖镇","320581400":"虞山林场","320581401":"常熟经济技术开发区","320581402":"江苏省常熟高新技术产业开发区","320581403":"常熟虞山尚湖旅游度假区","320581404":"江苏常熟服装城管理委员会","320581405":"碧溪街道","320581406":"常熟昆承湖管理委员会","320581407":"常熟国家大学科技园","320581408":"东南街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320581.json
// module id = 805
// module chunks = 0